import { render, staticRenderFns } from "./QuoteBuilderMiscHeadingsComponent.vue?vue&type=template&id=80538234&scoped=true"
import script from "./QuoteBuilderMiscHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderMiscHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderMiscHeadingsComponent.vue?vue&type=style&index=0&id=80538234&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80538234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80538234')) {
      api.createRecord('80538234', component.options)
    } else {
      api.reload('80538234', component.options)
    }
    module.hot.accept("./QuoteBuilderMiscHeadingsComponent.vue?vue&type=template&id=80538234&scoped=true", function () {
      api.rerender('80538234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderMisc/QuoteBuilderMiscHeadingsComponent.vue"
export default component.exports